import React from "react"
import styles from "./index.module.scss"
import Close from "@mui/icons-material/Close"

type TagContent = string

interface ITags {
  tags: TagContent[],
  flexDirection?: "col" | "row"
  onDeleteTag?: (tag: string) => void
}

const Tags: React.FC<ITags> = ({tags, flexDirection = "col", onDeleteTag}) => {
  return (
    <div className={flexDirection === "col" ? styles.TagContainerCol : styles.TagContainerRow}>
      {
        tags.map((tag, i) => (
          <div
            className={styles.Tag}
            key={`tag-${i}`}
          >

            {
              onDeleteTag
                ?
                <div className={styles.OnDeleteTagText}>
                  {tag.toUpperCase()}
                </div>
                :
                <div className={styles.TagText}>
                  {tag.toUpperCase()}
                </div>
            }

            {
              onDeleteTag &&
              <button
                onClick={() => onDeleteTag(tag)}
                className={styles.DeleteButton}
              >
                <Close/>
              </button>
            }
          </div>
        ))
      }
    </div>
  )
}

export default Tags
